module.exports = __webpack_public_path__ + "band_5.93f7b489.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_5.png
// module id = 7Wq4
// module chunks = 0